import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useState } from "react";
import { ReactComponent as RibbonIcon } from "../assets/img/ribbon.svg";
import { classNames } from "../common/functions";

type KonoGuaranteeBadgeProps = {
  small?: boolean;
  bordered?: boolean;
  compact?: boolean;
  className?: string;
};

export const KonoGuaranteeBadge = ({
  small,
  bordered,
  compact,
  className,
}: KonoGuaranteeBadgeProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleDivClick = () => {
    if (compact) {
      setIsOpen(true);
    }
  };

  const alignCss = small ? "mt-[0.1em]" : "mt-[0.2em]";
  return (
    <>
      <div
        className={classNames(
          "inline-block",
          compact && "cursor-pointer",
          className,
        )}
        onClick={handleDivClick}
      >
        <div
          className={`flex items-center gap-2 ${small ? "text-xs" : "text-sm"} ${bordered ? "border-2 p-2 rounded-full" : ""}`}
        >
          <div className="flex font-semibold">
            <RibbonIcon className={`w-4 h-4 ${alignCss} mr-1`} /> Kono Guarantee
          </div>
          {!compact && (
            <button
              type="button"
              onClick={() => setIsOpen(true)}
              className="text-gray-500 underline ml-1"
            >
              Learn more
            </button>
          )}
        </div>
      </div>
      <Transition.Root show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-40" onClose={setIsOpen}>
          <Transition.Child
            as={Fragment}
            enter="transition-opacity ease-linear duration-200"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="transition-opacity ease-linear duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 z-40 flex items-center justify-center p-4">
            <Transition.Child
              as={Fragment}
              enter="transition ease-out duration-200"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="transition ease-in duration-150"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-md rounded-2xl bg-white p-6 shadow-xl">
                <Dialog.Title className="text-lg font-semibold text-gray-900">
                  Kono Guarantee
                </Dialog.Title>
                <p className="mt-3 text-sm text-gray-600">
                  We guarantee that items will be delivered within the lead time
                  window provided at checkout. Material certificates are
                  provided within 24 hours of checkout where applicable. If
                  there are any issues with your order, our support team is here
                  to help resolve them quickly and to your satisfaction.
                </p>
                <p className="mt-3 text-sm text-gray-600">
                  Questions? Email us at support@kono.ai
                </p>
                <div className="mt-6 flex justify-end">
                  <button
                    type="button"
                    onClick={() => setIsOpen(false)}
                    className="rounded-full bg-[#00062e] px-4 py-2 text-sm font-bold text-white hover:bg-slate-900 focus:bg-slate-900"
                  >
                    Close
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  );
};
